import axios from "axios";
import { getTokenFromCookie } from "../utils/getCookies";

const token = getTokenFromCookie();
axios.defaults.baseURL = `${process.env.REACT_APP_API}`;
axios.defaults.headers["cache-control"] = "no-cache";
if (token !== "undefined" && token !== undefined) {
  axios.defaults.headers["Authorization"] = `Bearer ${token}`;
}
